import React, { useEffect, useState } from 'react';
import Card from '../../components/ui/Card';
import Btn from '../../components/ui/Btn';
import Secao from '../../components/ui/Secao';
import { Input, Select } from '../../components/ui/Input';
import SelecionarItensPropostaModal from '../../components/SelecionarItensPropostaModal';
import ClienteSearchModal from '../../components/ClienteSearchModal';
import CopiarPropostaModal from '../../components/CopiarPropostaModal';
import CriarCondicaoPagamentoModal from '../cadastros/CriarCondicaoPagamentoModal';
import { propostasApi } from '../../api/vendas';
import { clientesTenantApi } from '../../api/clientes';
import { condicoesPagamentoApi } from '../../api/condicoesPagamento';
import { transportadorasApi } from '../../api/transportadoras';
import { usuariosApi } from '../../api/admin';
import { funcionariosApi } from '../../api/rh';
import { regioesEntregaApi } from '../../api/regioesEntrega';
import { COLORS } from '../../theme';
import { useTituloPagina } from '../../context/PageTitleContext';
import { useAuth } from '../../context/AuthContext';

export const OPCOES_SITUACAO = [
  { value: 'em_elaboracao', label: 'Em Elaboração' },
  { value: 'enviada', label: 'Enviada ao Cliente' },
  { value: 'negociacao', label: 'Em Negociação' },
  { value: 'aprovada', label: 'Aprovada' },
  { value: 'recusada', label: 'Recusada' }
];

export const OPCOES_CATEGORIA = [
  { value: '', label: 'Sem categoria' },
  { value: 'varejo', label: 'Varejo' },
  { value: 'corporativo', label: 'Corporativo' },
  { value: 'licitacao', label: 'Licitação' }
];

const VALIDADES_PRESET = [2, 15, 30];

const ENDERECO_VAZIO = { entrega_logradouro: '', entrega_numero: '', entrega_complemento: '', entrega_bairro: '', entrega_cidade: '', entrega_uf: '', entrega_cep: '' };

function observacoesPadrao(nomeVendedor) {
  return `Agradecemos a oportunidade e ficamos à disposição para quaisquer esclarecimentos.\n\nAtenciosamente,\n${nomeVendedor || ''}`;
}

export default function PropostaForm({ propostaId, copiarDeId, onVoltar, onSalvo }) {
  const modoEdicao = !!propostaId;
  const idParaCarregar = propostaId || copiarDeId;
  useTituloPagina(modoEdicao ? 'Editar Proposta' : (copiarDeId ? 'Nova Proposta (Cópia)' : 'Nova Proposta'));
  const { usuario, empresaAtual, empresaAtualId } = useAuth();

  const [carregando, setCarregando] = useState(!!idParaCarregar);
  const [numero, setNumero] = useState(null);
  const [criadoEm, setCriadoEm] = useState(null);
  const [empresaNome, setEmpresaNome] = useState(null);
  const [pedidos, setPedidos] = useState([]);
  const [numeroNotaFiscal, setNumeroNotaFiscal] = useState(null);

  const [condicoes, setCondicoes] = useState([]);
  const [transportadoras, setTransportadoras] = useState([]);
  const [vendedores, setVendedores] = useState([]);
  const [funcionarios, setFuncionarios] = useState([]);

  const [clienteId, setClienteId] = useState('');
  const [clienteSelecionado, setClienteSelecionado] = useState(null);
  const [endereco, setEndereco] = useState(ENDERECO_VAZIO);

  const [condicaoPagamentoId, setCondicaoPagamentoId] = useState('');
  const [valeMercadoria, setValeMercadoria] = useState(false);
  const [valeMercadoriaFuncionarioId, setValeMercadoriaFuncionarioId] = useState('');
  const [prazoEntregaDias, setPrazoEntregaDias] = useState('');
  const [regiaoSugerida, setRegiaoSugerida] = useState('');
  const [validadeDias, setValidadeDias] = useState('15');
  const [tipoFrete, setTipoFrete] = useState('fob');
  const [transportadoraId, setTransportadoraId] = useState('');
  const [entregaPropria, setEntregaPropria] = useState(false);
  const [situacao, setSituacao] = useState('em_elaboracao');
  const [categoria, setCategoria] = useState('');
  const [segundoVendedorId, setSegundoVendedorId] = useState('');
  const [observacoes, setObservacoes] = useState(() => modoEdicao ? '' : observacoesPadrao(usuario?.nome));
  const [observacoesInternas, setObservacoesInternas] = useState('');
  const [negociacaoObservacao, setNegociacaoObservacao] = useState('');

  const [itens, setItens] = useState([]);
  const [selecionandoItens, setSelecionandoItens] = useState(false);
  const [buscandoCliente, setBuscandoCliente] = useState(false);
  const [criandoCondicao, setCriandoCondicao] = useState(false);
  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState('');

  const carregarCondicoes = () => condicoesPagamentoApi.listar().then(setCondicoes).catch(() => {});

  useEffect(() => {
    carregarCondicoes();
    transportadorasApi.listar().then(setTransportadoras).catch(() => {});
    usuariosApi.listarVendedores().then(setVendedores).catch(() => {});
    funcionariosApi.listarAtivosLista().then(setFuncionarios).catch(() => {});
  }, []);

  const [copiandoAberto, setCopiandoAberto] = useState(false);

  const preencherComProposta = async (proposta, { ehEdicao }) => {
    if (ehEdicao) {
      setNumero(proposta.numero);
      setCriadoEm(proposta.criado_em);
      setPedidos(proposta.pedidos || []);
      setNumeroNotaFiscal(proposta.numero_nota_fiscal);
      setEmpresaNome(proposta.empresa_nome);
    }

    setClienteId(proposta.cliente_id);
    try {
      const cliente = await clientesTenantApi.obter(proposta.cliente_id);
      setClienteSelecionado(cliente);
    } catch (e) { /* segue sem os dados extras do cliente */ }

    setEndereco({
      entrega_logradouro: proposta.entrega_logradouro || '',
      entrega_numero: proposta.entrega_numero || '',
      entrega_complemento: proposta.entrega_complemento || '',
      entrega_bairro: proposta.entrega_bairro || '',
      entrega_cidade: proposta.entrega_cidade || '',
      entrega_uf: proposta.entrega_uf || '',
      entrega_cep: proposta.entrega_cep || ''
    });
    setCondicaoPagamentoId(proposta.condicao_pagamento_id || '');
    setValeMercadoria(!!proposta.vale_mercadoria_funcionario_id);
    setValeMercadoriaFuncionarioId(proposta.vale_mercadoria_funcionario_id || '');
    setPrazoEntregaDias(proposta.prazo_entrega_dias ? String(proposta.prazo_entrega_dias) : '');
    setValidadeDias(proposta.validade_dias ? String(proposta.validade_dias) : '');
    setTipoFrete(proposta.tipo_frete || 'fob');
    setTransportadoraId(proposta.transportadora_id || '');
    setEntregaPropria(!!proposta.entrega_propria);
    setSituacao(proposta.situacao || 'em_elaboracao');
    setCategoria(proposta.categoria || '');
    setSegundoVendedorId(proposta.segundo_vendedor_id || '');
    setObservacoes(proposta.observacoes || (!ehEdicao ? observacoesPadrao(usuario?.nome) : ''));
    setObservacoesInternas(proposta.observacoes_internas || '');
    setNegociacaoObservacao(ehEdicao ? (proposta.negociacao_observacao || '') : '');
    setItens((proposta.itens || []).map(i => ({
      produto_id: i.produto_id, produto_codigo: i.produto_codigo, produto_nome: i.produto_nome,
      quantidade: String(i.quantidade), valor_unitario: Number(i.valor_unitario).toFixed(2),
      desconto_pct: String(i.desconto_pct || 0), ipi_pct: String(i.ipi_pct || 0),
      margem_promocao_valor: i.margem_promocao_valor,
      // Cópia de proposta começa uma negociação nova — não herda a aprovação anterior do gestor.
      valor_aprovado_gerente: ehEdicao ? i.valor_aprovado_gerente : null
    })));
  };

  useEffect(() => {
    if (!idParaCarregar) return;
    propostasApi.obter(idParaCarregar)
      .then(proposta => preencherComProposta(proposta, { ehEdicao: modoEdicao }))
      .then(() => setCarregando(false))
      .catch(() => setCarregando(false));
  }, [idParaCarregar]); // eslint-disable-line

  const copiarDeProposta = async (id) => {
    setCopiandoAberto(false);
    setCarregando(true);
    try {
      const proposta = await propostasApi.obter(id);
      await preencherComProposta(proposta, { ehEdicao: false });
    } catch (e) { /* segue com o formulário como estava */ }
    setCarregando(false);
  };

  const selecionarCliente = async (clienteBasico) => {
    setBuscandoCliente(false);
    setClienteId(clienteBasico.id);
    const cliente = await clientesTenantApi.obter(clienteBasico.id);
    setClienteSelecionado(cliente);
    const usarEntrega = !!cliente.end_entrega_logradouro;
    setEndereco({
      entrega_logradouro: (usarEntrega ? cliente.end_entrega_logradouro : cliente.end_principal_logradouro) || '',
      entrega_numero: (usarEntrega ? cliente.end_entrega_numero : cliente.end_principal_numero) || '',
      entrega_complemento: (usarEntrega ? cliente.end_entrega_complemento : cliente.end_principal_complemento) || '',
      entrega_bairro: (usarEntrega ? cliente.end_entrega_bairro : cliente.end_principal_bairro) || '',
      entrega_cidade: (usarEntrega ? cliente.end_entrega_cidade : cliente.end_principal_cidade) || '',
      entrega_uf: (usarEntrega ? cliente.end_entrega_uf : cliente.end_principal_uf) || '',
      entrega_cep: (usarEntrega ? cliente.end_entrega_cep : cliente.end_principal_cep) || ''
    });
    if (cliente.condicao_pagamento_id) setCondicaoPagamentoId(cliente.condicao_pagamento_id);

    const uf = usarEntrega ? cliente.end_entrega_uf : cliente.end_principal_uf;
    const cidade = usarEntrega ? cliente.end_entrega_cidade : cliente.end_principal_cidade;
    setRegiaoSugerida('');
    if (uf) {
      try {
        const resultado = await regioesEntregaApi.prazoParaEndereco(uf, cidade);
        if (resultado?.prazo_entrega_dias) {
          setPrazoEntregaDias(String(resultado.prazo_entrega_dias));
          setRegiaoSugerida(resultado.regiao_nome || '');
        } else {
          setPrazoEntregaDias('');
        }
      } catch (e) { /* sem região cadastrada pra esse endereço — segue sem sugestão */ }
    }
  };
  const opcoesCondicoes = [{ value: '', label: 'Selecione...' }, ...condicoes.map(c => ({ value: c.id, label: c.nome }))];
  const opcoesTransportadoras = [{ value: '', label: 'Selecione...' }, ...transportadoras.map(t => ({ value: t.id, label: t.nome_fantasia }))];
  const opcoesVendedores = [{ value: '', label: 'Nenhum' }, ...vendedores.map(v => ({ value: v.id, label: v.nome }))];
  const opcoesFuncionarios = [{ value: '', label: 'Selecione o funcionário...' }, ...funcionarios.map(f => ({ value: f.id, label: f.nome }))];

  const adicionarItem = (item) => setItens(i => [...i, item]);
  const removerItem = (idx) => setItens(i => i.filter((_, x) => x !== idx));
  const atualizarItem = (idx, campo, valor) => setItens(i => i.map((item, x) => x === idx ? { ...item, [campo]: valor } : item));

  const subtotalItem = (i) => (Number(i.quantidade) || 0) * (Number(i.valor_unitario) || 0) * (1 - (Number(i.desconto_pct) || 0) / 100) * (1 + (Number(i.ipi_pct) || 0) / 100);
  const totalGeral = itens.reduce((s, i) => s + subtotalItem(i), 0);

  const salvar = async () => {
    if (!modoEdicao && !empresaAtualId) { setErro('Selecione a empresa no topo da tela antes de criar a proposta'); return; }
    if (!clienteId) { setErro('Selecione o cliente'); return; }
    const itensValidos = itens.filter(i => i.produto_id && i.quantidade && i.valor_unitario);
    if (itensValidos.length === 0) { setErro('Adicione ao menos um item com quantidade e valor'); return; }
    if (valeMercadoria && !valeMercadoriaFuncionarioId) { setErro('Selecione o funcionário do Vale Mercadoria'); return; }
    setSalvando(true);
    setErro('');
    try {
      const payload = {
        ...(modoEdicao ? {} : { empresa_id: empresaAtualId }),
        cliente_id: clienteId,
        condicao_pagamento_id: valeMercadoria ? null : (condicaoPagamentoId || null),
        vale_mercadoria_funcionario_id: valeMercadoria ? valeMercadoriaFuncionarioId : null,
        prazo_entrega_dias: prazoEntregaDias || null,
        validade_dias: validadeDias || null,
        observacoes,
        observacoes_internas: observacoesInternas,
        ...endereco,
        tipo_frete: tipoFrete,
        transportadora_id: transportadoraId || null,
        entrega_propria: entregaPropria,
        situacao,
        categoria: categoria || null,
        segundo_vendedor_id: segundoVendedorId || null,
        itens: itensValidos.map(i => ({ produto_id: i.produto_id, quantidade: i.quantidade, valor_unitario: i.valor_unitario, desconto_pct: i.desconto_pct || 0, ipi_pct: i.ipi_pct || 0, valor_aprovado_gerente: i.valor_aprovado_gerente || null }))
      };
      if (modoEdicao) await propostasApi.atualizar(propostaId, payload);
      else await propostasApi.criar(payload);
      if (onSalvo) onSalvo();
      onVoltar();
    } catch (e) {
      setErro(e.message);
    } finally {
      setSalvando(false);
    }
  };

  const naoSalvar = () => {
    if (modoEdicao && !window.confirm('Sair sem salvar as alterações feitas nessa proposta?')) return;
    onVoltar();
  };

  const excluirProposta = async () => {
    if (!window.confirm('Excluir esta proposta? Essa ação não pode ser desfeita.')) return;
    setSalvando(true);
    setErro('');
    try {
      await propostasApi.excluir(propostaId);
      if (onSalvo) onSalvo();
      onVoltar();
    } catch (e) {
      setErro(e.message);
    } finally {
      setSalvando(false);
    }
  };

  if (carregando) return null;

  return (
    <div>
      <Card>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12, marginBottom: 16, borderBottom: `1px solid ${COLORS.border}`, paddingBottom: 14 }}>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 18, fontSize: 12 }}>
            <div><span style={{ color: COLORS.textLight }}>Empresa:</span> <strong style={{ color: COLORS.text }}>{modoEdicao ? (empresaNome || '-') : (empresaAtual?.nome || 'Nenhuma selecionada')}</strong></div>
            <div><span style={{ color: COLORS.textLight }}>Nº Proposta:</span> <strong style={{ color: numero ? COLORS.text : COLORS.textMid }}>{numero ? `#${numero}` : '(gerado ao salvar)'}</strong></div>
            <div><span style={{ color: COLORS.textLight }}>Nº Pedido:</span> <strong style={{ color: COLORS.textMid }}>{(() => { const p = pedidos.find(p => p.status !== 'cancelado'); return p ? `#${p.numero}` : '(gerado ao efetivar)'; })()}</strong></div>
            <div><span style={{ color: COLORS.textLight }}>Nº NF:</span> <strong style={{ color: COLORS.textMid }}>{numeroNotaFiscal || '(gerado ao faturar)'}</strong></div>
            <div><span style={{ color: COLORS.textLight }}>Data:</span> <strong style={{ color: COLORS.text }}>{criadoEm ? new Date(criadoEm).toLocaleDateString('pt-BR') : new Date().toLocaleDateString('pt-BR')}</strong></div>
          </div>
          <div style={{ display: 'flex', gap: 10 }}>
            <Btn variante="ghost" onClick={naoSalvar} disabled={salvando}>{modoEdicao ? 'Não Salvar' : 'Voltar'}</Btn>
            {!modoEdicao && <Btn variante="secondary" onClick={() => setCopiandoAberto(true)}>Copiar de Proposta Existente</Btn>}
            {modoEdicao && pedidos.length === 0 && (
              <Btn variante="danger" onClick={excluirProposta} disabled={salvando}>Excluir Proposta</Btn>
            )}
            <Btn onClick={salvar} disabled={salvando}>{salvando ? 'Salvando...' : (modoEdicao ? 'Salvar Alterações' : 'Criar Proposta')}</Btn>
          </div>
        </div>
        {erro && <p style={{ color: COLORS.danger, fontSize: 13, marginTop: 0 }}>{erro}</p>}

        {negociacaoObservacao && (
          <div style={{ background: COLORS.warningBg, border: `1px solid ${COLORS.warning}66`, borderRadius: 10, padding: 14, marginBottom: 16 }}>
            <div style={{ fontSize: 11, fontWeight: 700, color: '#92400E', textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: 4 }}>
              Observação do Gestor (Negociação)
            </div>
            <p style={{ margin: 0, fontSize: 13, color: COLORS.text }}>{negociacaoObservacao}</p>
          </div>
        )}

        <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: 14, alignItems: 'start' }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            <Secao titulo="Cliente">
              {clienteSelecionado ? (
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12 }}>
                  <div>
                    <div style={{ fontSize: 14, fontWeight: 600 }}>{clienteSelecionado.nome_fantasia}</div>
                    <div style={{ marginTop: 6, fontSize: 12, color: COLORS.textMid, display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 3 }}>
                      <div>Contato: {clienteSelecionado.contato_nome || '-'}{clienteSelecionado.contato_email ? ` · ${clienteSelecionado.contato_email}` : ''}</div>
                      <div>Telefone: {clienteSelecionado.telefone1 || '-'}</div>
                      <div style={{ gridColumn: '1 / -1' }}>
                        Endereço: {clienteSelecionado.end_principal_logradouro || '-'}{clienteSelecionado.end_principal_numero ? `, ${clienteSelecionado.end_principal_numero}` : ''}
                        {clienteSelecionado.end_principal_bairro ? ` — ${clienteSelecionado.end_principal_bairro}` : ''}
                        {clienteSelecionado.end_principal_cidade ? `, ${clienteSelecionado.end_principal_cidade}` : ''}{clienteSelecionado.end_principal_uf ? `/${clienteSelecionado.end_principal_uf}` : ''}
                      </div>
                    </div>
                  </div>
                  <Btn tamanho="sm" variante="ghost" onClick={() => setBuscandoCliente(true)}>Trocar Cliente</Btn>
                </div>
              ) : (
                <Btn variante="secondary" onClick={() => setBuscandoCliente(true)}>Buscar Cliente</Btn>
              )}
            </Secao>

            <Secao titulo="Endereço de Entrega">
              <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1.5fr', gap: 6 }}>
                  <Input label="Logradouro" value={endereco.entrega_logradouro} onChange={e => setEndereco(v => ({ ...v, entrega_logradouro: e.target.value }))} />
                  <Input label="Número" value={endereco.entrega_numero} onChange={e => setEndereco(v => ({ ...v, entrega_numero: e.target.value }))} />
                  <Input label="Complemento" value={endereco.entrega_complemento} onChange={e => setEndereco(v => ({ ...v, entrega_complemento: e.target.value }))} />
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1.5fr 1.5fr 0.6fr 1fr', gap: 6 }}>
                  <Input label="Bairro" value={endereco.entrega_bairro} onChange={e => setEndereco(v => ({ ...v, entrega_bairro: e.target.value }))} />
                  <Input label="Cidade" value={endereco.entrega_cidade} onChange={e => setEndereco(v => ({ ...v, entrega_cidade: e.target.value }))} />
                  <Input label="UF" maxLength={2} value={endereco.entrega_uf} onChange={e => setEndereco(v => ({ ...v, entrega_uf: e.target.value }))} />
                  <Input label="CEP" value={endereco.entrega_cep} onChange={e => setEndereco(v => ({ ...v, entrega_cep: e.target.value }))} />
                </div>
              </div>
              {clienteSelecionado && <p style={{ fontSize: 11, color: COLORS.textLight, marginTop: 6, marginBottom: 0 }}>Preenchido a partir do cadastro do cliente — pode ser alterado se a entrega for pra outro endereço.</p>}
            </Secao>

            <Secao titulo="Frete">
              <div style={{ display: 'flex', gap: 20, alignItems: 'center', marginBottom: tipoFrete === 'cif' ? 10 : 0 }}>
                <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13 }}>
                  <input type="radio" checked={tipoFrete === 'fob'} onChange={() => setTipoFrete('fob')} /> FOB (cliente retira/contrata)
                </label>
                <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13 }}>
                  <input type="radio" checked={tipoFrete === 'cif'} onChange={() => setTipoFrete('cif')} /> CIF (frete por nossa conta)
                </label>
              </div>
              {tipoFrete === 'cif' && (
                <div style={{ display: 'grid', gridTemplateColumns: '1fr auto', gap: 14, alignItems: 'end', maxWidth: 560 }}>
                  <Select label="Transportadora" options={opcoesTransportadoras} value={transportadoraId}
                    onChange={e => setTransportadoraId(e.target.value)} disabled={entregaPropria} />
                  <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, paddingBottom: 9 }}>
                    <input type="checkbox" checked={entregaPropria} onChange={e => { setEntregaPropria(e.target.checked); if (e.target.checked) setTransportadoraId(''); }} />
                    Entrega Própria
                  </label>
                </div>
              )}
            </Secao>

            <div style={{ background: '#EFF6FF', border: '1px solid #BFDBFE', borderRadius: 10, padding: 14 }}>
              <Secao titulo="Itens" acao={<Btn tamanho="sm" variante="secondary" onClick={() => setSelecionandoItens(true)}>+ Adicionar Produtos</Btn>}>
                <div style={{ background: '#fff', border: `1px solid ${COLORS.border}`, borderRadius: 8, overflow: 'hidden' }}>
                  <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                    <thead>
                      <tr style={{ textAlign: 'left', background: '#DBEAFE' }}>
                        <th style={{ padding: '5px 8px' }}>Produto</th>
                        <th style={{ padding: '5px 8px', width: 110 }}>Quantidade</th>
                        <th style={{ padding: '5px 8px', width: 130 }}>Valor Unit. R$</th>
                        <th style={{ padding: '5px 8px', width: 80 }}>Desc. %</th>
                        <th style={{ padding: '5px 8px', width: 80 }}>IPI %</th>
                        <th style={{ padding: '5px 8px', width: 120 }}>Subtotal</th>
                        <th style={{ padding: '5px 8px', width: 90 }} />
                      </tr>
                    </thead>
                    <tbody>
                      {itens.map((item, idx) => {
                        const abaixoPromocao = item.margem_promocao_valor != null && Number(item.valor_unitario) < Number(item.margem_promocao_valor);
                        return (
                        <tr key={idx} style={{ borderTop: `1px solid ${COLORS.border}`, background: abaixoPromocao ? COLORS.warningBg : undefined }}
                          title={abaixoPromocao ? `Abaixo da tabela Promoção (R$ ${Number(item.margem_promocao_valor).toFixed(2)}) — vai para negociação ao efetivar` : undefined}>
                          <td style={{ padding: '4px 8px', fontSize: 12 }}><strong>{item.produto_codigo}</strong> — {item.produto_nome}</td>
                          <td style={{ padding: '4px 8px' }}>
                            <Input type="number" step="0.001" value={item.quantidade} onChange={e => atualizarItem(idx, 'quantidade', e.target.value)} />
                          </td>
                          <td style={{ padding: '4px 8px' }}>
                            <Input type="number" step="0.01" value={item.valor_unitario} style={abaixoPromocao ? { borderColor: COLORS.warning, color: '#92400E', fontWeight: 700 } : undefined} onChange={e => atualizarItem(idx, 'valor_unitario', e.target.value)} />
                          </td>
                          <td style={{ padding: '4px 8px' }}>
                            <Input type="number" step="0.01" min="0" max="100" value={item.desconto_pct} onChange={e => atualizarItem(idx, 'desconto_pct', e.target.value)} />
                          </td>
                          <td style={{ padding: '4px 8px' }}>
                            <Input type="number" step="0.01" min="0" value={item.ipi_pct} onChange={e => atualizarItem(idx, 'ipi_pct', e.target.value)} />
                          </td>
                          <td style={{ padding: '4px 8px', fontWeight: 600 }}>
                            R$ {subtotalItem(item).toFixed(2)}
                          </td>
                          <td style={{ padding: '4px 8px' }}>
                            <Btn variante="danger" tamanho="sm" onClick={() => removerItem(idx)}>Remover</Btn>
                          </td>
                        </tr>
                        );
                      })}
                      {itens.length === 0 && (
                        <tr><td colSpan={7} style={{ padding: 20, textAlign: 'center', color: COLORS.textMid }}>Nenhum item adicionado ainda.</td></tr>
                      )}
                    </tbody>
                    {itens.length > 0 && (
                      <tfoot>
                        <tr style={{ background: '#EFF6FF' }}>
                          <td colSpan={5} style={{ padding: 8, textAlign: 'right', fontWeight: 700 }}>Total</td>
                          <td colSpan={2} style={{ padding: 8, fontWeight: 700 }}>R$ {totalGeral.toFixed(2)}</td>
                        </tr>
                      </tfoot>
                    )}
                  </table>
                </div>
              </Secao>
            </div>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            <Secao titulo="Condições da Proposta">
              <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                <div>
                  {!valeMercadoria && (
                    <>
                      <Select label="Condição de Pagamento" options={opcoesCondicoes} value={condicaoPagamentoId} onChange={e => setCondicaoPagamentoId(e.target.value)} />
                      <button type="button" onClick={() => setCriandoCondicao(true)}
                        style={{ background: 'none', border: 'none', color: COLORS.primary, fontSize: 12, cursor: 'pointer', padding: '4px 0' }}>
                        + Nova Condição
                      </button>
                    </>
                  )}
                  <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, fontWeight: 600, cursor: 'pointer', marginTop: valeMercadoria ? 0 : 6 }}>
                    <input type="checkbox" checked={valeMercadoria}
                      onChange={e => { setValeMercadoria(e.target.checked); if (!e.target.checked) setValeMercadoriaFuncionarioId(''); }} />
                    Vale Mercadoria (descontado direto da folha do funcionário)
                  </label>
                  {valeMercadoria && (
                    <div style={{ marginTop: 8 }}>
                      <Select label="Funcionário" options={opcoesFuncionarios} value={valeMercadoriaFuncionarioId} onChange={e => setValeMercadoriaFuncionarioId(e.target.value)} />
                      <p style={{ fontSize: 11, color: COLORS.textLight, margin: '4px 0 0' }}>
                        Ao efetivar essa proposta, o valor total vira um desconto automático na folha de pagamento desse funcionário no mês corrente.
                      </p>
                    </div>
                  )}
                </div>
                <Select label="Situação" options={OPCOES_SITUACAO} value={situacao} onChange={e => setSituacao(e.target.value)} />
                <Select label="Categoria" options={OPCOES_CATEGORIA} value={categoria} onChange={e => setCategoria(e.target.value)} />
                <Select label="2º Vendedor" options={opcoesVendedores} value={segundoVendedorId} onChange={e => setSegundoVendedorId(e.target.value)} />
                <div>
                  <Input label="Prazo de Entrega (dias)" type="number" min="0" value={prazoEntregaDias} onChange={e => setPrazoEntregaDias(e.target.value)} />
                  {regiaoSugerida && <p style={{ fontSize: 11, color: COLORS.textLight, margin: '4px 0 0' }}>Sugerido pela região "{regiaoSugerida}" — pode alterar manualmente.</p>}
                </div>
              </div>
            </Secao>

            <Secao titulo="Validade da Proposta">
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'center' }}>
                {VALIDADES_PRESET.map(dias => (
                  <button key={dias} type="button" onClick={() => setValidadeDias(String(dias))}
                    style={{
                      padding: '6px 12px', borderRadius: 7, fontSize: 12, cursor: 'pointer',
                      border: `1.5px solid ${Number(validadeDias) === dias ? COLORS.primary : COLORS.border}`,
                      background: Number(validadeDias) === dias ? COLORS.primaryBg : '#fff',
                      color: Number(validadeDias) === dias ? COLORS.primary : COLORS.textMid, fontWeight: 600
                    }}>
                    {dias} dias
                  </button>
                ))}
                <Input type="number" value={validadeDias} onChange={e => setValidadeDias(e.target.value)} style={{ width: 90 }} />
              </div>
            </Secao>

            <Secao titulo="Observações (aparecem na proposta impressa)">
              <textarea value={observacoes} onChange={e => setObservacoes(e.target.value)} rows={6}
                style={{ width: '100%', border: `1.5px solid ${COLORS.border}`, borderRadius: 7, padding: '8px 9px', fontSize: 13, fontFamily: 'inherit', resize: 'vertical', boxSizing: 'border-box' }} />
            </Secao>

            <Secao titulo="Observações Internas (não saem na proposta impressa)">
              <textarea value={observacoesInternas} onChange={e => setObservacoesInternas(e.target.value)} rows={4}
                style={{ width: '100%', border: `1.5px solid ${COLORS.border}`, borderRadius: 7, padding: '8px 9px', fontSize: 13, fontFamily: 'inherit', resize: 'vertical', boxSizing: 'border-box' }} />
            </Secao>
          </div>
        </div>
      </Card>

      {buscandoCliente && (
        <ClienteSearchModal onSelecionar={selecionarCliente} onFechar={() => setBuscandoCliente(false)} />
      )}

      {selecionandoItens && (
        <SelecionarItensPropostaModal
          itensAtuais={itens}
          onAdicionarItem={adicionarItem}
          onRemoverItem={removerItem}
          onFechar={() => setSelecionandoItens(false)}
        />
      )}

      {criandoCondicao && (
        <CriarCondicaoPagamentoModal
          onFechar={() => setCriandoCondicao(false)}
          onCriada={(id) => { setCriandoCondicao(false); carregarCondicoes().then(() => setCondicaoPagamentoId(id)); }}
        />
      )}

      {copiandoAberto && (
        <CopiarPropostaModal
          onFechar={() => setCopiandoAberto(false)}
          onSelecionar={copiarDeProposta}
        />
      )}
    </div>
  );
}
